<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="机构id,外键{zb_organization.id}" prop="organizationId">-->
<!--                <a-input v-model="queryParam.organizationId" placeholder="请输入机构id,外键{zb_organization.id}" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="8" :sm="24">
              <a-form-item label="教师名称" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入教师名称" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">

<!--              <a-col :md="8" :sm="24">-->
<!--                <a-form-item label="教师简介" prop="introduction">-->
<!--                  <a-input v-model="queryParam.introduction" placeholder="请输入教师简介" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['teacher:teacher:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['teacher:teacher:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['teacher:teacher:remove']">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['teacher:teacher:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
       <span slot="index" slot-scope="text, record, index">
          {{ getIndex(record, index) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="picture" slot-scope="text, record">
          <img :src="record.picture" style="width: 100px; height: 100px;">
        </span>
        <span slot="label" slot-scope="text, record">
          {{ convertLabelIdsToNames(record.label) }}
        </span>
        <span slot="video" slot-scope="text,record">
          <video  controls width="100" height="100">
          <source :src="record.video" type="video/mp4">
        </video>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['teacher:teacher:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['teacher:teacher:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['teacher:teacher:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['teacher:teacher:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageTeacher,listTeacher, delTeacher } from '@/api/teacher/teacher'
import { getDicts } from '@/api/system/dict/data'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Teacher',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      teacherLabelDict: [], // 教师标签字典数据
      // 查询参数
      queryParam: {
        organizationId: null,
        name: null,
        picture: null,
        label: null,
        introduction: null,
        content: null,
        video: null,
        pageNum: 1,
        total: 0,
        current: 0,
        size: 0,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '教师表id',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        {
          title: '机构名称',
          dataIndex: 'organizationName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '教师名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '教师图片',
          dataIndex: 'picture',
          ellipsis: true,
          scopedSlots: { customRender: 'picture' },
          align: 'center'
        },
        {
          title: '教师标签',
          dataIndex: 'label',
          ellipsis: true,
          scopedSlots: { customRender: 'label' },
          align: 'center'
        },
        {
          title: '教师简介',
          dataIndex: 'introduction',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '教师介绍',
          dataIndex: 'content',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '教师访谈视频',
          dataIndex: 'video',
          ellipsis: true,
          scopedSlots: { customRender: 'video' },
          align: 'center'
        },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getTeacherLabelDict()
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 获取教师标签字典数据 */
    getTeacherLabelDict () {
      getDicts('teacher_label').then(response => {
        this.teacherLabelDict = response.data || []
      }).catch(() => {
        this.teacherLabelDict = []
      })
    },

    /** 查询机构教师列表 */
    getList () {
      this.loading = true
     pageTeacher(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        organizationId: undefined,
        name: undefined,
        picture: undefined,
        label: undefined,
        introduction: undefined,
        content: undefined,
        video: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 获取序号 - 递归计算 */
    getIndex (record, index) {
      // 对于树形表格，序号计算比较复杂
      // 这里简化处理，使用index+1
      // 如果需要更准确的序号，可以在构建树时添加序号属性
      return index + 1
    },

    /** 将教师标签ID转换为名称 */
    convertLabelIdsToNames (labelIds) {
      if (!labelIds) return ''

      const ids = labelIds.split(',').map(id => id.trim()).filter(id => id)
      if (ids.length === 0) return ''

      const names = ids.map(id => {
        const dictItem = this.teacherLabelDict.find(item => item.dictValue == id)
        return dictItem ? dictItem.dictLabel : id
      })

      return names.join(', ')
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delTeacher(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('teacher/teacher/export', {
            ...that.queryParam
          }, `机构教师_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
